var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContract = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.187,
    height: 71.475,
    viewBox: "0 0 57.187 71.475",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M87.418,0H58.823a7.138,7.138,0,0,0-7.111,7.148l-.036,57.189a7.138,7.138,0,0,0,7.113,7.138h42.926a7.17,7.17,0,0,0,7.147-7.148V21.443Zm3.469,55.284C84.4,61.668,82.9,61.668,82.4,61.668c-1.85,0-2.513-2.123-3.2-4.4-1.038,2.107-2.234,4.4-4.246,4.4a5.762,5.762,0,0,1-3.441-1.72,15.688,15.688,0,0,1-1.623,1.422A1.489,1.489,0,1,1,68.1,58.988a13.732,13.732,0,0,0,1.422-1.253,9.373,9.373,0,0,1-2.018-5c0-3.4,2.711-5.956,4.467-5.956a4.394,4.394,0,0,1,4.467,4.467c0,1.9-1.318,4.349-2.958,6.468a3.517,3.517,0,0,0,1.483.977,16.627,16.627,0,0,0,1.669-2.956c.89-1.806,1.477-3,2.783-3,1.527,0,2,1.584,2.606,3.589a21.711,21.711,0,0,0,.73,2.161A62.24,62.24,0,0,0,88.8,53.161a1.489,1.489,0,0,1,2.088,2.123Zm3.674-14.646H65.971V33.49h28.59ZM83.837,25.014V5.362L103.5,25.021Z",
    transform: "translate(-51.676)",
    fill: "#e3e3e3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContract);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Contract.ca10c248537e3e25585c31f71803437d.svg";